import Resource from '@/services/resources/common';

// question type
export default class StructureActivityResource extends Resource {
  constructor(entrypoint = '/structure_activities', alias = 'StructureActivity') {
    super(entrypoint, alias);
  }
}
